import { StaticImageData } from 'next/image'
import FlexibilityImage1x from './hero-flexibility@1x.png'
import FlexibilityImage2x from './hero-flexibility@2x.png'
import ScalabilityImage1x from './hero-scalability@1x.png'
import ScalabilityImage2x from './hero-scalability@2x.png'
import SimplicityImage1x from './hero-simplicity@1x.png'
import SimplicityImage2x from './hero-simplicity@2x.png'

export type DifferenceHeroDataType = {
  title: string
  caption: string
  image1x: StaticImageData
  image2x: StaticImageData
}

export const differenceHeroData: DifferenceHeroDataType[] = [
  {
    title: 'Flexibility of custom development but fast and bug-free.',
    caption: 'Flexibility of custom development',
    image1x: FlexibilityImage1x,
    image2x: FlexibilityImage2x,
  },
  {
    title: 'Scalability of Unified API but flexible and extensible.',
    caption: 'Scalability of Unified API',
    image1x: ScalabilityImage1x,
    image2x: ScalabilityImage2x,
  },
  {
    title: 'Simplicity of iPaaS but scalable and API-first.',
    caption: 'Simplicity of iPaaS',
    image1x: SimplicityImage1x,
    image2x: SimplicityImage2x,
  },
]
